import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import PayUForm from './Utils/PayUForm';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
//import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
//import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import UtilityBillsDthPay from './Recharge/UtilityBillsDthPay';
import WifiInternet from './Recharge/WifiInternet';
import { useSelector } from "react-redux";
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import ncell from '../../../assets/img/ncell.jpg';
import ntcPrepaid from '../../../assets/img/ntcPrepaid.jpg';
let amountData = [
  50, 70, 100, 120, 130, 140, 143, 150, 160, 170, 180, 190, 200, 240, 250, 260, 280, 290, 300, 350, 360, 370, 380, 390, 400, 410, 420, 430, 440, 450, 460, 470, 480, 490, 500, 510, 520, 530, 540, 550, 560, 570, 580, 590, 600, 610, 620, 630, 640, 650, 660, 670, 680, 690, 700, 710, 720, 730, 740, 750, 760, 770, 780, 790, 800, 850, 900, 1000
]
function Recharge() {
  const currentUser = useSelector((state) => state.data);
  const [errors, setErrors] = useState(false);
  const [formData, setFormData] = useState(false);
  const [mobileNumber, setMobileNumber] = useState(false);
  const [operatorCode, setOperatorCode] = useState(false);
  const [providers, setProviders] = useState(false);
  const [amount, setAmount] = useState(0);
  const [payuData, setPayuData] = useState(false);
  const [rechargeType, setRechargeType] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [postpaidAmount, setPostpaidAmount] = useState(false);
  const [dataPackage, setDataPackage] = useState({ ntc: false, ncell: false });
  const getMobileNumber = async (e, type) => {
    let mobile = e.target.value;
    if (mobile.length <= 10) {
      setPostpaidAmount(false);
      setFormData({ MobileNumber: mobile });
      if (['977', '984', '986', '987', '961', '962'].includes(mobile.substring(0, 3))) {
        getOperatorCode(1, type, mobile.length);
      }
      else if (['880', '980', '981', '982', '970', '971'].includes(mobile.substring(0, 3))) {
        getOperatorCode(2, type, mobile.length);
      }
      else if (['974', '975', '976'].includes(mobile.substring(0, 3))) {
        getOperatorCode(3, type, mobile.length);
      }
      else if (['985'].includes(mobile.substring(0, 3))) {
        getOperatorCode(4, type, mobile.length);
        if (mobile.length == 10) {
          try {
            const response = await axios.post('/recharge/checkPostpaidBalance', { mobile });
            const { status, amount } = response.data;
            if (status) {
              setPostpaidAmount(amount);
            }
          }
          catch (error) {
            if (error?.response?.data?.message) {
              toast(error.response.data.message);
            }
          }
        }
      }
      else {
        getOperatorCode(false, type, mobile.length);
      }
      setMobileNumber(mobile);
    }
  };
  const getOperatorCode = (status, type, mobileLength) => {
    setOperatorCode(status);
    if (type == "package" && mobileLength == 10) {
      getRechargeType(status);
    }
  };
  const fetchRechargeData = (amount) => {
    let npr = amount / 1.6;
    let processingFee = npr * 8 / 100;
    let gst = processingFee * 18 / 100;
    let total = npr + processingFee + gst;
    let payumoneyCharges = total * 2.36 / 100;
    let totalAmt = total + payumoneyCharges;
    setTotalAmount(totalAmt);
  };
  const getAmount = (e) => {
    setAmount(e.target.value);
    fetchRechargeData(e.target.value);
  };
  const getPackage = (value, id) => {
    if (id == 1) {
      setAmount(dataPackage.ntc[value].Amount);
      fetchRechargeData(dataPackage.ntc[value].Amount);
    }
    else {
      setAmount(dataPackage.ncell[value].Amount);
      fetchRechargeData(dataPackage.ncell[value].Amount);
    }
  };
  const getRechargeType = async (status) => {
    setRechargeType(status);
    try {
      if (status == 1) {
        const response = await axios.post('/recharge/get/prabhu/operator', { OperatorCode: 124, service_provider: "66388b52e73547e41e69e794" });
        const { status, data } = response.data;
        if (status) {
          setDataPackage({ ...dataPackage, ntc: data.Packages });
        }
      }
      if (status == 2) {
        const response = await axios.post('/recharge/get/prabhu/operator', { OperatorCode: 77, service_provider: "66388b34e73547e41e69e793" });
        const { status, data } = response.data;
        if (status) {
          setDataPackage({ ...dataPackage, ncell: data.Packages });
        }
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { OperatorCode, MobileNumber, Amount, wallet_type, package_id } = e.target;
    try {
      const isValid = /^\d{10}$/.test(MobileNumber.value);
      if (!isValid) {
        setErrors({ MobileNumber: "Mobile should be 10 number" });
      }
      else {
        setErrors(false);
        let sendData = {
          service: "recharge",
          service_provider: OperatorCode.value,
          mobile: MobileNumber.value,
          amount,
          wallet_type: wallet_type.value,
          plan_id: package_id && (operatorCode && operatorCode == 1 ? dataPackage.ntc[package_id?.value].Code : dataPackage.ncell[package_id?.value].Code),
        };
        const response = await axios.post("/recharge/online/payment", sendData);
        const { status, message, hashData, rechage_response: rd } = response.data;
        if (status) {
          if (hashData) {
            const payuData = {
              hash: hashData.hash,
              txnid: hashData.txId,
              amount: hashData.amount,
              firstname: currentUser.name,
              email: currentUser.email,
            };
            setPayuData(payuData);
          }
          else {
            let rechrgeMessage = "<table align='center'><tr><td>Mobile</td><td>" + rd.mobile + "</td></tr><tr><td>Amount</td><td>" + rd.amount + "</td></tr><tr><td>Receipt</td><td>" + rd.reciept + "</td></tr><tr><td>Transaction ID</td><td>" + rd.transaction_id + "</td></tr><tr><td colspan='100%'>" + rd.message + "</td></tr></table>"
            Swal.fire({
              title: 'Recharge Successful!',
              html: rechrgeMessage,
              icon: 'success',
              //confirmButtonText: 'OK'
            });
            setOperatorCode(false);
            setFormData({ MobileNumber: "" });
          }
        }
        else {
          toast(message);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getData = async () => {
    try {
      const response = await axios.get('/admin/get/all/providers/NEPALESE', { params: { category_name: "Nepal Recharge" } });
      const { status, data } = response.data;
      if (status) {
        setProviders(data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      {
        payuData && (
          <PayUForm formData={payuData} autoSubmit={true} />
        )
      }
      <div class="content-wrapper">
        <div class="row">
          <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Recharge</h4>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={3}>
                      <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                          <Nav.Link eventKey="first">Mobile Topup</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="second">Package</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="third">UtilityBill/DTHPay</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="fourth">WiFiInternet/BillsPay</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9}>
                      <Tab.Content>
                        <Tab.Pane eventKey="first">
                          <Form onSubmit={handleSubmit}>
                            <div className="row">
                              <div class="col-lg-12 col-md-12">
                                <label>Mobile Number</label>
                                <input class="form-control" type="number" name="MobileNumber" value={formData?.MobileNumber} onChange={(e) => getMobileNumber(e, "topup")} required />
                                <span className="error">{errors && errors?.MobileNumber}</span>
                              </div>
                              {
                                operatorCode && (
                                  operatorCode == 1 ? (
                                    <div class="col-lg-12 col-md-12">
                                      {
                                        (providers && providers.length > 0) && providers.map((provider) => (
                                          (["Active", "Inactive"].includes(provider.status) && provider.provider_service == "1") && (
                                            <>
                                              <input type="hidden" name="OperatorCode" value={provider._id} />
                                              {/* <div><center><b>NTC Prepaid</b></center></div> */}
                                            </>
                                          )
                                        ))
                                      }
                                    </div>
                                  ) : operatorCode == 2 ? (
                                    <div class="col-lg-12 col-md-12">
                                      {
                                        (providers && providers.length > 0) && providers.map((provider) => (
                                          (["Active", "Inactive"].includes(provider.status) && provider.provider_service == "2") && (
                                            <>
                                              <input type="hidden" name="OperatorCode" value={provider._id} />
                                              {/* <div><center><b>NCELL Prepaid</b></center></div> */}
                                            </>
                                          )
                                        ))
                                      }
                                    </div>
                                  ) : operatorCode == 3 ? (
                                    <div class="col-lg-12 col-md-12">
                                      {
                                        (providers && providers.length > 0) && providers.map((provider) => (
                                          (["Active", "Inactive"].includes(provider.status) && provider.provider_service == "9") && (
                                            <>
                                              <input type="hidden" name="OperatorCode" value={provider._id} />
                                              {/* <div><center><b>NT (CDMA) - SKY Prepaid</b></center></div> */}
                                            </>
                                          )
                                        ))
                                      }
                                    </div>
                                  ) : operatorCode == 4 ? (
                                    <div class="col-lg-12 col-md-12">
                                      {
                                        (providers && providers.length > 0) && providers.map((provider) => (
                                          (["Active", "Inactive"].includes(provider.status) && provider.provider_service == "225") && (
                                            <>
                                              <input type="hidden" name="OperatorCode" value={provider._id} />
                                              {/* <div><center><b>NT (CDMA) - SKY Prepaid</b></center></div> */}
                                            </>
                                          )
                                        ))
                                      }
                                    </div>
                                  ) : ""
                                )
                              }
                              {
                                <div className="operators">
                                  <div className={operatorCode && operatorCode == 1 && 'active'}>NTC Prepaid</div>
                                  <div className={operatorCode && operatorCode == 2 && 'active'}>NCELL Prepaid</div>
                                  <div className={operatorCode && operatorCode == 3 && 'active'}>NT (CDMA)</div>
                                  <div className={operatorCode && operatorCode == 4 && 'active'}>NT Postpaid</div>
                                </div>
                              }
                              {
                                operatorCode && (
                                  <>
                                    <div class="col-lg-12 col-md-12">
                                      <label>Wallet Type</label>
                                      <select class="form-control" name="wallet_type" required>
                                        <option value="">--Select--</option>
                                        <option value="wallet">Wallet</option>
                                        <option value="remitance">Remitance</option>
                                        <option value="payu">Online payment(Payu)</option>
                                      </select>
                                    </div>
                                    <div class="col-lg-12 col-md-12">
                                      <label>Amount</label>
                                      {
                                        postpaidAmount ? (
                                          <input type="text" class="form-control" name="Amount" value={postpaidAmount} />
                                        ) : (
                                          <select class="form-control" name="Amount" onChange={getAmount} required>
                                            <option value="">--Select--</option>
                                            {amountData.map((amount, index) => (
                                              <option value={amount}>
                                                {amount}
                                              </option>
                                            ))}
                                          </select>
                                        )
                                      }
                                    </div>
                                    <div class="col-lg-12 col-md-12">
                                      <input type="submit" className="search-btn btn btn-primary" value="Recharge" />
                                    </div>
                                  </>
                                )
                              }
                            </div>
                          </Form>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                          <Form onSubmit={handleSubmit}>
                            <div className="row">
                              <div class="col-lg-12 col-md-12">
                                <label>Mobile Number</label>
                                <input class="form-control" type="number" name="MobileNumber" value={formData?.MobileNumber} onChange={(e) => getMobileNumber(e, "package")} required />
                                <span className="error">{errors && errors?.MobileNumber}</span>
                              </div>
                              {
                                operatorCode && (
                                  operatorCode == 1 ? (
                                    <div class="col-lg-12 col-md-12">
                                      {
                                        (providers && providers.length > 0) && providers.map((provider) => (
                                          (["Active", "Inactive"].includes(provider.status) && provider.provider_service == "124") && (
                                            <>
                                              <input type="hidden" name="OperatorCode" value={provider._id} />
                                              {/* <div><center><b>NTC Prepaid</b></center></div> */}
                                            </>
                                          )
                                        ))
                                      }
                                    </div>
                                  ) : operatorCode == 2 ? (
                                    <div class="col-lg-12 col-md-12">
                                      {
                                        (providers && providers.length > 0) && providers.map((provider) => (
                                          (["Active", "Inactive"].includes(provider.status) && provider.provider_service == "77") && (
                                            <>
                                              <input type="hidden" name="OperatorCode" value={provider._id} />
                                              {/* <div><center><b>NCELL Prepaid</b></center></div> */}
                                            </>
                                          )
                                        ))
                                      }
                                    </div>
                                  ) : ""
                                )
                              }
                              {
                                <div className="operators">
                                  <div className={operatorCode && operatorCode == 1 && 'active'}>NTC Prepaid</div>
                                  <div className={operatorCode && operatorCode == 2 && 'active'}>NCELL Prepaid</div>
                                </div>
                              }
                              {
                                operatorCode && (
                                  <>
                                    <div class="col-lg-12 col-md-12">
                                      <label>Wallet Type</label>
                                      <select class="form-control" name="wallet_type" required>
                                        <option value="">--Select--</option>
                                        <option value="wallet">Wallet</option>
                                        <option value="remitance">Remitance</option>
                                        <option value="payu">Online payment(Payu)</option>
                                      </select>
                                    </div>
                                    {
                                      rechargeType == 1 ? (
                                        <div class="col-lg-12 col-md-12">
                                          <label>Packages</label>
                                          <select class="form-control" name="package_id" onChange={(e) => getPackage(e.target.value, 1)} required>
                                            <option value="">--Select--</option>
                                            {(dataPackage && dataPackage.ntc) && (dataPackage.ntc).map((item, index) => (
                                              <option value={index}>
                                                {item.Name}| NPR {item.Amount}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      ) : (
                                        <div class="col-lg-12 col-md-12">
                                          <label>Packages</label>
                                          <select class="form-control" name="package_id" onChange={(e) => getPackage(e.target.value, 2)} required>
                                            <option value="">--Select--</option>
                                            {(dataPackage && dataPackage.ncell) && (dataPackage.ncell).map((item, index) => (
                                              <option value={index}>
                                                {item.Name}| NPR {item.Amount}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      )
                                    }
                                    <div class="col-lg-12 col-md-12">
                                      <input type="submit" className="search-btn btn btn-primary" value="Recharge" />
                                    </div>
                                  </>
                                )
                              }
                            </div>
                          </Form>
                        </Tab.Pane>
                        <Tab.Pane eventKey="third"><UtilityBillsDthPay /></Tab.Pane>
                        <Tab.Pane eventKey="fourth"><WifiInternet /></Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Recharge;
